/* PELUX · Chantier conversion du 14/10 — zone « avis » de la fiche du harnais
   (thème de test « page parfaite », review/cro-2026-10-14/CHARTE.md).
   Mur d'avis : section pelux-temoignages (note, répartition, filtres, cartes, « Voir plus », appel à témoigner).
   Chargé en defer seulement sur la fiche du harnais, après pelux-preuve.js (layout/theme.liquid).
   Custom elements ou délégation sur le document : les blocs re-rendus (variantes, prix) remplacent
   leur DOM à chaque changement de variante.

   Ce script prépare chaque <pelux-avis-mur> (assets/pelux-preuve.js, qui garde filtres et lots) :
   1. Ordre annoncé dans « Comment sont recueillis les avis ? » : mis en avant d'abord, puis du plus
      récent au plus ancien. Les lots y sont déjà ; pour les vrais témoignages, l'ordre que rend
      l'admin n'est pas garanti.
   2. « dont N ces 30 derniers jours » : compté sur les dates des avis à l'heure du visiteur (la page
      est en cache chez Shopify), montré à partir de 3 avis.
   3. « Ce qui revient dans les avis » : chaque sujet (libellé et mots repérés dans les fichiers de
      langue, pelux.cro_avis.sujets) est cherché dans le TITRE et le TEXTE de chaque avis — jamais le
      prénom, la ville ni le nom du chat. Le compte affiché est le nombre d'avis qui en parlent :
      aucun chiffre écrit à la main. Un sujet n'apparaît qu'à partir de 2 avis, 6 sujets au plus,
      du plus cité au moins cité. Un appui filtre le mur (data-sujets, filtre « sujets:cle ») et
      surligne les passages trouvés ; « Taille » montre en plus le lien du guide des tailles.
   Sans JavaScript : rien de tout cela ne s'affiche (les blocs partent en `hidden`). */
(function () {
  'use strict';

  var JOUR = 86400000;
  var SEUIL_SUJET = 2;
  var MAX_SUJETS = 6;
  var SEUIL_RECENTS = 3;
  var ZONES_TEXTE = '.pelux-avis-carte__titre, .pelux-avis-carte__texte';

  function nfc(texte) {
    return texte.normalize ? texte.normalize('NFC') : texte;
  }

  /* Texte « plié » pour la recherche : minuscules, sans accents, apostrophe droite. Chaque caractère
     en donne exactement un : les positions trouvées valent dans le texte d'origine (surlignage). */
  function plier(texte) {
    var sortie = '';
    for (var i = 0; i < texte.length; i++) {
      var c = texte.charAt(i);
      var p = (c.normalize ? c.normalize('NFD') : c).replace(/[̀-ͯ]/g, '').toLowerCase();
      if (p === '’' || p === 'ʼ') p = "'";
      sortie += p.length === 1 ? p : (p.charAt(0) || ' ');
    }
    return sortie;
  }

  /* « taille*|tour de cou » → source d'expression régulière. Chaque motif commence un mot ; « * » final :
     n'importe quelle fin de mot (surlignée jusqu'au bout du mot), sinon le mot entier. Groupe 2 = le
     passage trouvé. */
  function expression(liste) {
    var motifs = [];
    String(liste || '').split('|').forEach(function (brut) {
      var m = plier(nfc(brut.trim()));
      if (!m) return;
      var prefixe = /\*$/.test(m);
      m = m.replace(/\*+$/, '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      if (m) motifs.push(prefixe ? m + '[a-z0-9]*' : m + '(?![a-z0-9])');
    });
    return motifs.length ? '(^|[^a-z0-9])(' + motifs.join('|') + ')' : null;
  }

  function texteCarte(carte) {
    return Array.prototype.map.call(carte.querySelectorAll(ZONES_TEXTE), function (e) {
      return e.textContent;
    }).join(' \n ');
  }

  function aSujet(carte, cle) {
    return (' ' + (carte.getAttribute('data-sujets') || '') + ' ').indexOf(' ' + cle + ' ') !== -1;
  }

  function surligner(carte, source) {
    var re = new RegExp(source, 'g');
    Array.prototype.forEach.call(carte.querySelectorAll(ZONES_TEXTE), function (bloc) {
      var marcheur = document.createTreeWalker(bloc, NodeFilter.SHOW_TEXT, null);
      var noeuds = [];
      while (marcheur.nextNode()) noeuds.push(marcheur.currentNode);
      noeuds.forEach(function (noeud) {
        var brut = nfc(noeud.data);
        if (brut !== noeud.data) noeud.data = brut;
        var plie = plier(brut);
        var trouves = [];
        var m;
        re.lastIndex = 0;
        while ((m = re.exec(plie))) {
          var debut = m.index + m[1].length;
          trouves.push([debut, debut + m[2].length]);
          if (re.lastIndex === m.index) re.lastIndex += 1;
        }
        for (var k = trouves.length - 1; k >= 0; k--) {
          var milieu = noeud.splitText(trouves[k][0]);
          milieu.splitText(trouves[k][1] - trouves[k][0]);
          var marque = document.createElement('mark');
          marque.className = 'pelux-cro-avis__surligne';
          marque.setAttribute('data-cro-surligne', '');
          milieu.parentNode.replaceChild(marque, milieu);
          marque.appendChild(milieu);
        }
      });
    });
  }

  function effacerSurlignage(racine) {
    Array.prototype.forEach.call(racine.querySelectorAll('[data-cro-surligne]'), function (marque) {
      var parent = marque.parentNode;
      while (marque.firstChild) parent.insertBefore(marque.firstChild, marque);
      parent.removeChild(marque);
      parent.normalize();
    });
  }

  function preparer(mur) {
    if (mur.hasAttribute('data-cro-avis') || typeof mur.rendre !== 'function') return;
    mur.setAttribute('data-cro-avis', '');
    var cartes = Array.prototype.slice.call(mur.querySelectorAll('[data-avis-carte]'));
    if (!cartes.length) return;
    var maintenant = Date.now();

    /* 1. Ordre : mis en avant, puis du plus récent au plus ancien ; à égalité, l'ordre du serveur. */
    var fiches = cartes.map(function (carte, i) {
      var t = carte.querySelector('time[datetime]');
      var date = t ? Date.parse(t.getAttribute('datetime')) : NaN;
      return { carte: carte, i: i, avant: carte.hasAttribute('data-avant') ? 1 : 0, date: isNaN(date) ? 0 : date };
    });
    fiches.sort(function (a, b) {
      return (b.avant - a.avant) || (b.date - a.date) || (a.i - b.i);
    });
    var grille = mur.querySelector('.pelux-mur__grille');
    var deplace = fiches.some(function (f, k) { return f.i !== k; });
    if (grille && deplace) {
      fiches.forEach(function (f) { grille.appendChild(f.carte); });
    }
    mur.cartes = fiches.map(function (f) { return f.carte; });

    /* 2. Avis datés des 30 derniers jours. */
    var recents = fiches.filter(function (f) {
      return f.date && f.date <= maintenant + JOUR && maintenant - f.date <= 30 * JOUR;
    }).length;
    var zoneRecents = mur.querySelector('[data-cro-recents]');
    if (zoneRecents && recents >= SEUIL_RECENTS) {
      zoneRecents.textContent = (zoneRecents.getAttribute('data-modele') || '').replace('[n]', recents);
      zoneRecents.hidden = false;
    }

    /* 3. Sujets qui reviennent. */
    var zone = mur.querySelector('[data-cro-sujets]');
    var sujets = [];
    if (zone) {
      sujets = Array.prototype.map.call(zone.querySelectorAll('[data-filtre^="sujets:"]'), function (bouton) {
        var source = expression(bouton.getAttribute('data-motifs'));
        return { bouton: bouton, cle: bouton.getAttribute('data-filtre').slice(7), source: source, re: source ? new RegExp(source) : null, n: 0 };
      }).filter(function (s) { return s.re; });
      cartes.forEach(function (carte) {
        var texte = plier(nfc(texteCarte(carte)));
        var trouves = sujets.filter(function (s) { return s.re.test(texte); });
        trouves.forEach(function (s) { s.n += 1; });
        if (trouves.length) {
          carte.setAttribute('data-sujets', trouves.map(function (s) { return s.cle; }).join(' '));
        } else {
          carte.removeAttribute('data-sujets');
        }
      });
      var liste = zone.querySelector('.pelux-cro-avis__puces');
      var modele = zone.getAttribute('data-modele') || '';
      var montres = sujets.filter(function (s) { return s.n >= SEUIL_SUJET; })
        .sort(function (a, b) { return b.n - a.n; })
        .slice(0, MAX_SUJETS);
      montres.forEach(function (s) {
        var nb = s.bouton.querySelector('[data-nb]');
        if (nb) nb.textContent = s.n;
        s.bouton.setAttribute('aria-label', modele.replace('[sujet]', s.bouton.getAttribute('data-libelle') || '').replace('[n]', s.n));
        s.bouton.hidden = false;
        if (liste) liste.appendChild(s.bouton);
      });
      zone.hidden = montres.length === 0;
    }

    /* 4. Selon le filtre actif : surlignage des passages, lien du guide des tailles. */
    var guide = zone ? zone.querySelector('[data-cro-guide]') : null;
    var surligne = 'tous';
    mur.addEventListener('pelux:avis-rendu', function (e) {
      var filtre = (e.detail && e.detail.filtre) || 'tous';
      if (guide) guide.hidden = filtre !== 'sujets:taille';
      if (filtre === surligne) return;
      effacerSurlignage(mur);
      surligne = filtre;
      if (filtre.indexOf('sujets:') !== 0) return;
      var cle = filtre.slice(7);
      sujets.forEach(function (s) {
        if (s.cle !== cle) return;
        cartes.forEach(function (carte) {
          if (aSujet(carte, cle)) surligner(carte, s.source);
        });
      });
    });

    /* 5. Le mur se redessine dans son ordre définitif (même lot qu'au chargement). */
    mur.rendre(false);
  }

  function tout(racine) {
    Array.prototype.forEach.call(racine.querySelectorAll('pelux-avis-mur'), preparer);
  }

  if (!window.customElements) return;
  customElements.whenDefined('pelux-avis-mur').then(function () { tout(document); });
  /* Éditeur de thème : une section re-rendue arrive avec un mur neuf. */
  document.addEventListener('shopify:section:load', function (e) {
    customElements.whenDefined('pelux-avis-mur').then(function () { tout(e.target); });
  });
})();
